import { Box, Dialog, DialogContent, withStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import CrossImg from "../../Assets/images/cross-icon.svg";
import ErrorImg from "../../Assets/images/warning-img.svg";
import { domainRenewalDetails, toggleDomainRenewalModal, toggleWorkspaceExpiryModal } from "../../Redux/Actions";
import { RootState } from "../../Redux/Reducers";
import { getDaysDiffFromToday, parseToJson } from "../../Utils/common";
import { ToastNotifyError } from "../Toast";
import "./style.scss";

const CustomDialog = withStyles({
  root: {
    "& .MuiDialog-paperWidthMd": {
      maxWidth: 554,
      width: "100%",
      borderRadius: 8,
    },
  },
})(Dialog);

const CustomDialogContent = withStyles({
  root: {
    padding: "32px 40px",
    "&:first-child": {
      paddingTop: 48,
    },
  },
})(DialogContent);

const WorkspaceExpiryModal = (): JSX.Element => {
  const dispatch = useDispatch();
  const { expiryModalView, storeData, subscriptionDetails } = useSelector((state: RootState) => ({
    expiryModalView: state.commonReducer.workspaceExpiryModalView,
    storeData: state.storeReducer.store,
    subscriptionDetails: state.themeReducer.subscriptionDetails,
  }));

  const expiryMessage = () => {
    return getDaysDiffFromToday(storeData?.domain_info?.expiry_date) <= 0 ? "has expired." : "is about to expire.";
  };

  const domainName = () => subscriptionDetails?.domain?.entity_id || storeData?.domain_info?.domain;

  const closeModal = () => {
    dispatch(toggleWorkspaceExpiryModal(false));
  };

  const renewDomainBtnClick = () => {
    const payload = {
      domain: domainName(),
      year: 1,
    };
    const callback = (status: boolean) => {
      if (status) {
        closeModal();
        dispatch(toggleDomainRenewalModal(true));
      } else {
        ToastNotifyError("Cannot renew domain currently. Please try again later!");
      }
    };
    dispatch(domainRenewalDetails(payload, callback));
  };

  return (
    <CustomDialog open={expiryModalView} maxWidth="md">
      <CustomDialogContent className="workspace-expiry-modal">
        <div className="relative">
          <img className="pointer cross-image" src={CrossImg} onClick={closeModal} />
        </div>
        <img src={ErrorImg} />
        <h2>{domainName()}</h2>
        <p className="fw4">
          Dear User, your workspace account may stop working because the domain associated with it {expiryMessage()}
          <br />
          <Box component="span" color="#C73737">
            Please renew your domain to prevent workspace from expiring
          </Box>
        </p>
        <div className="flex justify-end pt4">
          <button className="renew-domain-btn" onClick={renewDomainBtnClick}>
            Renew Domain
          </button>
        </div>
      </CustomDialogContent>
    </CustomDialog>
  );
};

export default WorkspaceExpiryModal;
